import { useSelector } from "react-redux";
import { Typography } from "@mui/material";

import { Card } from "ui/Card";

import { selectUserId } from "fond/api";
import { useInviteAcceptance } from "fond/invitation/useHandleInviteAcceptance";
import { NoContentIcon } from "fond/svg_icons";
import { AccountInvitation } from "fond/types";

type AcceptInvitationPanelProps = {
  invitations: AccountInvitation[];
};

export const AcceptInvitationPanel = ({ invitations }: AcceptInvitationPanelProps): JSX.Element => {
  const userId = useSelector(selectUserId);
  const { handleInviteAcceptance } = useInviteAcceptance();
  const invitation = invitations[0];
  const accountName = invitation.Account?.Name;

  const acceptInvitationClick = async () => {
    handleInviteAcceptance(invitation.ID);
  };

  return (
    <Card
      title={<b>No content?</b>}
      description={
        <>
          <Typography variant="body1" fontWeight={500} mb={2}>
            It looks like you've been invited to join {accountName ? `the ${accountName}` : "an"} account.
          </Typography>
          <Typography maxWidth="60ch">If you join this account you will be able to access a shared workspace to create and share designs.</Typography>
        </>
      }
      icon={<NoContentIcon style={{ alignSelf: "start" }} />}
      buttonText="Accept invitation"
      onClick={acceptInvitationClick}
    />
  );
};
